import type Decimal from 'decimal.js';
import { formatDecimalAsPrice } from '@/utils/string.utils';

// Amounts are signed from the CSE's side (a créance is negative), but the salarié-facing
// convention carries the direction in the colour alone: red for a dette, green for a créance.
export function DebtOrCreanceAmount({ amount }: { amount: Decimal }) {
  const colorClassName = amount.gt(0) ? 'text-red-600' : amount.lt(0) ? 'text-green-600' : '';
  return (
    <span className={`font-medium ${colorClassName}`}>{formatDecimalAsPrice(amount.abs())}</span>
  );
}
